import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

/* eslint-disable no-new */
const store = new Vuex.Store({
	plugins: [createPersistedState()],
	modules: {
	},
	state() {
		return {
			dictionary: {},
			readingLevel: 1
		}
	},
	mutations: {
		Initialize(state, data) {
			if(!state.dictionary) state.dictionary = {};
			for(let key in data)
			{
				if(!state.dictionary[key]) state.dictionary[key] = data[key];
				if(!state.dictionary[key].reading) state.dictionary[key].reading = []; 
				if(!state.dictionary[key].readingCombo) state.dictionary[key].readingCombo = 0;
				if(!state.dictionary[key].readingScore) state.dictionary[key].readingScore = 0;
			}
		},
		UpdateChar(state, data)
		{
			state.dictionary[data.key] = data.data;
		},
		ReadingLevelUp(state, data)
		{
			state.readingLevel++;
		}
	}
})

export default store
